// i18n/homePage.js
// export const heroHomePage = {
//   en: [
//     { title: "achieve", subtitle: "clear growth" },
//     { title: "stronger", subtitle: "performance" },
//     { title: "measurable", subtitle: "return on investment." },
//   ],
//   vi: [
//     { title: "đạt được", subtitle: "tăng trưởng rõ ràng" },
//     { title: "mạnh mẽ hơn", subtitle: "hiệu suất" },
//     { title: "đo lường", subtitle: "hiệu quả đầu tư." },
//   ],
// };

export const heroHomePage = {
  en: {
    heading: "For Business Owners",

    lines: [
      { title: "achieve", subtitle: "clear growth" },
      { title: "stronger", subtitle: "performance" },
      { title: "measurable", subtitle: "return on investment." },
    ],

    description:
      "Unlock your business potential with strategic coaching, structured guidance, and ROI-focused solutions that help you grow profitably, streamline operations, and lead with impact.",

    cta: "Start Growing Your Business Today.",
  },

  vi: {
    heading: "Dành cho chủ doanh nghiệp",

    lines: [
      { title: "đạt được", subtitle: "tăng trưởng rõ ràng" },
      { title: "mạnh mẽ hơn", subtitle: "hiệu suất" },
      { title: "đo lường", subtitle: "hiệu quả đầu tư." },
    ],

    description:
      "Mở khóa tiềm năng doanh nghiệp với chiến lược rõ ràng, hướng dẫn có hệ thống tập trung vào hiệu quả đầu tư, giúp bạn tăng trưởng bền vững, tối ưu vận hành và nâng cao năng lực lãnh đạo.",

    cta: "Phát triển doanh nghiệp của bạn hôm nay.",
  },
};

export const heroButtons = {
  en: {
    start: "Get Started",
    book: "Book a call",
  },
  vi: {
    start: "Bắt đầu",
    book: "Đặt lịch",
  },
};

export const introHomePage = {
  en: {
    titleTop: "Business Coach & Advisor",
    title: "Maria Pooley",
    p1: "Maria Pooley is the founder of Maria Advisory.",
    p2: "With over 20 years of international experience across export/import and real estate, Maria brings deep practical insight into business operations and leadership effectiveness.",
    hightlight: [
      {
        value: "20+",
        label: "Years Exp.",
      },
      {
        value: "HPTC",
        label: "Certified Coach",
      },
      {
        value: "MNZ",
        label: "Advisory Board",
      },
    ],
    cta: "Learn More",
  },
  vi: {
    title: "Về Maria Pooley & Maria Advisory",
    p1: "Maria Pooley là nhà sáng lập Maria Advisory.",
    p2: "Với hơn 20 năm kinh nghiệm quốc tế trong lĩnh vực xuất nhập khẩu và bất động sản, Maria mang đến góc nhìn thực tiễn sâu sắc về vận hành và hiệu quả lãnh đạo.",
    hightlight: [
      {
        value: "20+",
        label: "Năm Kinh Nghiệm",
      },
      {
        value: "HPTC",
        label: "Huấn luyện viên",
      },
      {
        value: "MNZ",
        label: "Hội đồng Cố vấn",
      },
    ],
    cta: "Tìm hiểu thêm",
  },
};

export const servicesHomePage = {
  en: {
    titleTop: "Our Services",

    title: "Grow your business\nwith clear strategy",
    subtitle:
      "Maria Pooley and Maria Advisory provide the expertise, structure, and accountability to support your next stage of growth",
    button: "Learn more",
  },
  vi: {
    titleTop: "Dịch Vụ",

    title: "Phát triển doanh nghiệp\nvới chiến lược rõ ràng",
    subtitle:
      "Maria Pooley và Maria Advisory mang đến chuyên môn, cấu trúc và sự đồng hành để hỗ trợ giai đoạn phát triển tiếp theo của bạn",
    button: "Tìm hiểu thêm",
  },
};

export const testimonialsHomePageText = {
  en: {
    sectionTitle: "Services",
    cards: [
      {
        quote: "Service 01",
        title: "Business ",
        subtitle: "Consulting Service",
        quote: "Operations · Revenue gap · 90-day plan",
        items: [],

        photo: "/maria/services/Business Consulting.png",
        path: "/services/business-consulting#businessconsulting",
        position: "leftTop",

        description:
          "Practical consulting solutions designed to help SMEs improve operations, profitability, and long-term business growth.",
      },

      {
        quote: "Service 02",
        title: "Business ",
        subtitle: "Investment Advisory",
        quote: "Business & property · ROI modelling",

        items: [],

        photo: "/maria/services/Business Investement.png",
        path: "/services/business-investment#businessinvestmentadvisory",
        position: "center",

        description:
          "Strategic investment guidance to help businesses grow smarter, minimise risk, and maximise long-term returns.",
      },

      {
        quote: "Service 03",
        title: "Property",
        subtitle: "Investment Advisory",
        quote: "High-value properties · Risk management",

        items: [],

        photo: "/maria/services/Property Investment.png",
        path: "/services/property-investment#propertyadvisory",
        position: "rightBottom",

        description:
          "Professional property investment guidance focused on sustainable growth, stronger returns, and smarter decisions.",
      },

      {
        quote: "Service 04",
        title: "Business ",
        subtitle: "Coaching & Training",
        quote: "8 sessions · 16 weeks · KPI system",
        favourite: "Most popular",
        items: [],

        photo: "/maria/services/Training & Coaching.png",
        path: "/services/training-coaching#trainingcoaching",
        position: "leftBottom",

        description:
          "Practical business training and coaching programs designed to improve leadership, performance, and business growth.",
      },

      {
        quote: "Service 05",
        title: "Leadership & Personal",
        subtitle: "Development",
        quote: "Mindset · Communication · Team culture",

        items: [
          "Build confidence and self-awareness",
          "Strengthen leadership mindset",
          "Improve communication skills",
          "Develop emotional resilience",
          "Create clearer personal direction",
        ],

        photo: "/maria/services/Leadership & Personal.png",
        path: "/services/leadership-development#consulting",
        position: "center",

        description:
          "Personal and professional development programs that help individuals lead with clarity, confidence, and purpose.",
      },

      {
        quote: "Service 06",
        title: "Become a Coach",
        subtitle: "& Coaching Business",
        quote: "Certified program · Build your practice",
        items: [],

        photo: "/maria/services/Become a Coach.png",
        path: "/services/coach-training#trainning",
        position: "rightTop",

        description:
          "Support and mentorship for aspiring coaches looking to build a successful and sustainable coaching business.",
      },
    ],
  },

  vi: {
    sectionTitle: "Dịch Vụ",
    cards: [
      {
        quote: "Dịch vụ 01",
        title: "Tư vấn",
        subtitle: "Doanh nghiệp",
        quote: "Vận hành · Doanh thu · Kế hoạch 90 ngày",

        items: [],

        photo: "/maria/services/Business Consulting.png",
        path: "/services/business-consulting#businessconsulting",
        position: "leftTop",

        description:
          "Giải pháp tư vấn thực tiễn giúp doanh nghiệp vừa và nhỏ tối ưu vận hành, nâng cao lợi nhuận và phát triển bền vững.",
      },

      {
        quote: "Dịch vụ 02",
        title: "Tư vấn",
        subtitle: "Đầu tư Doanh Nghiệp",
        quote: "Doanh nghiệp & bất động sản · Mô hình ROI",

        items: [],

        photo: "/maria/services/Business Investement.png",
        path: "/services/business-investment#businessinvestmentadvisory",
        position: "center",

        description:
          "Tư vấn đầu tư chiến lược giúp doanh nghiệp tăng trưởng thông minh, giảm thiểu rủi ro và tối đa hóa lợi nhuận dài hạn.",
      },

      {
        quote: "Dịch vụ 03",
        title: "Tư vấn",
        subtitle: "Đầu tư Bất động sản",
        quote: "Bất động sản giá trị · Quản trị rủi ro",

        items: [],

        photo: "/maria/services/Property Investment.png",
        path: "/services/property-investment#propertyadvisory",
        position: "rightBottom",

        description:
          "Dịch vụ tư vấn đầu tư bất động sản chuyên nghiệp, tập trung vào tăng trưởng bền vững và hiệu quả đầu tư lâu dài.",
      },

      {
        quote: "Dịch vụ 04",
        title: "Huấn Luyện",
        subtitle: "& Đào Tạo Doanh Nghiệp",
        quote: "8 buổi · 16 tuần · Hệ thống KPI",
        favourite: "Phổ biến nhất",

        items: [],

        photo: "/maria/services/Training & Coaching.png",
        path: "/services/training-coaching#trainingcoaching",
        position: "leftBottom",

        description:
          "Chương trình coaching và đào tạo thực tiễn giúp nâng cao năng lực lãnh đạo, hiệu suất làm việc và tăng trưởng doanh nghiệp.",
      },

      {
        quote: "Dịch vụ 05",
        title: "Phát triển",
        subtitle: "Lãnh đạo  & Bản Thân",
        quote: "Tư duy · Giao tiếp · Văn hóa đội ngũ",

        items: [
          "Xây dựng sự tự tin và nhận thức bản thân",
          "Phát triển tư duy lãnh đạo",
          "Nâng cao kỹ năng giao tiếp",
          "Tăng cường khả năng thích ứng và kiên cường",
          "Định hướng mục tiêu cá nhân rõ ràng hơn",
        ],

        photo: "/maria/services/Leadership & Personal.png",
        path: "/services/leadership-development#consulting",
        position: "center",

        description:
          "Chương trình phát triển cá nhân và nghề nghiệp giúp lãnh đạo với sự tự tin, rõ ràng và mục tiêu rõ rệt.",
      },

      {
        quote: "Dịch vụ 06",
        title: "Trở Thành Coach",
        subtitle: "& Phát Triển Coaching",
        quote: "Chứng nhận · Xây dựng nghề nghiệp",

        items: [],

        photo: "/maria/services/Become a Coach.png",
        path: "/services/coach-training#trainning",
        position: "rightTop",

        description:
          "Chương trình đào tạo và cố vấn dành cho những người muốn xây dựng sự nghiệp coaching chuyên nghiệp và bền vững.",
      },
    ],
  },
};

export const readyToGrowHomePage = {
  en: {
    title: "Ready to grow your business?",
    subtitle: "Book a free 30-minute discovery call with Maria",
    button1: "Enquire now",
    button2: "Learn more",
  },

  vi: {
    title: "Sẵn sàng phát triển doanh nghiệp?",
    subtitle: "Đặt lịch tư vấn miễn phí 30 phút cùng Maria",
    button1: "Liên hệ ngay",
    button2: "Tìm hiểu thêm",
  },
};
